import React, { useEffect } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { range } from 'lodash';

const SuccessionFixedPayment = ({ query, updateCfaQuery, intl }) => {
  const validate = () => {
    let valid = true;

    if (query.buyerHasFixedPayments == undefined) {
      valid = false;
    } else if (query.buyerHasFixedPayments) {
      if (!query.buyerFixedPaymentYears || parseFloat(query.buyerFixedPaymentYears) < 1) {
        valid = false;
      }

      if (!query.buyerFixedPaymentAmount || parseFloat(query.buyerFixedPaymentAmount) < 1) {
        valid = false;
      }
    }

    if (query.valid != valid) {
      updateCfaQuery({ ...query, valid });
    }
  };

  // Call validate on every render (matching original behavior)
  validate();

  const formatCurrency = (value) => {
    if (!value || value === '') return '';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  return (
    <div className="max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold text-gray-900 mb-4">
        <FormattedMessage id="calculators.cfa.fixed_header" />
      </h2>
      <div className="space-y-4 mb-8">
        <p className="text-gray-600">
          <FormattedMessage id="calculators.cfa.fixed_copy" />
        </p>
        <p className="text-gray-600">
          <FormattedMessage id="calculators.cfa.fixed_copy_2" />
        </p>
      </div>
      
      <div className="bg-white border border-gray-200 rounded-lg p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-6">
          <FormattedMessage id="calculators.cfa.fixed_payments" />
        </h3>
        
        <div className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-3">
              <FormattedMessage id="calculators.cfa.will_there_be_fixed_payments" />
            </label>
            <div className="flex space-x-4">
              <label className="flex items-center">
                <input
                  type="radio"
                  name="buyerHasFixedPayments"
                  checked={query.buyerHasFixedPayments === true}
                  onChange={() => {
                    updateCfaQuery({ ...query, buyerHasFixedPayments: true });
                  }}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                />
                <span className="ml-2 text-sm text-gray-700">
                  <FormattedMessage id="calculators.cfa.yes_label" />
                </span>
              </label>
              <label className="flex items-center">
                <input
                  type="radio"
                  name="buyerHasFixedPayments"
                  checked={query.buyerHasFixedPayments === false}
                  onChange={() => {
                    updateCfaQuery({ 
                      ...query, 
                      buyerHasFixedPayments: false,
                      buyerFixedPaymentYears: 0,
                      buyerFixedPaymentStartYear: 0,
                      buyerFixedPaymentAmount: 0
                    });
                  }}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                />
                <span className="ml-2 text-sm text-gray-700">
                  <FormattedMessage id="calculators.cfa.no_label" />
                </span>
              </label>
            </div>
          </div>

          {query.buyerHasFixedPayments && (
            <div className="space-y-6 ml-6 border-l-2 border-gray-200 pl-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <FormattedMessage id="calculators.cfa.how_many_years_fixed" />
                </label>
                <select
                  value={query.buyerFixedPaymentYears || ''}
                  onChange={(e) => {
                    updateCfaQuery({ ...query, buyerFixedPaymentYears: parseInt(e.target.value) });
                  }}
                  className="block w-full max-w-xs px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">
                    {intl.formatMessage({ id: "calculators.cfa.please_select_a_year" })}
                  </option>
                  {range(1, 6).map(year => (
                    <option key={year} value={year}>{year}</option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <FormattedMessage id="calculators.cfa.fixed_payment_start_year" />
                </label>
                <select
                  value={query.buyerFixedPaymentStartYear || ''}
                  onChange={(e) => {
                    updateCfaQuery({ ...query, buyerFixedPaymentStartYear: parseInt(e.target.value) });
                  }}
                  className="block w-full max-w-xs px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">
                    {intl.formatMessage({ id: "calculators.cfa.please_select_a_year" })}
                  </option>
                  {range(1, 6).map(year => (
                    <option key={year} value={year}>{year}</option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <FormattedMessage id="calculators.cfa.fixed_payment_per_year" />
                </label>
                <div className="relative max-w-xs">
                  <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-gray-500">$</span>
                  <input
                    type="text"
                    value={query.buyerFixedPaymentAmount ? formatCurrency(query.buyerFixedPaymentAmount).replace('$', '').replace(/,/g, '') : ''}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9.]/g, '');
                      updateCfaQuery({ ...query, buyerFixedPaymentAmount: parseFloat(value) || 0 });
                    }}
                    className="block w-full pl-8 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-right"
                    placeholder="0"
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default injectIntl(SuccessionFixedPayment); 